<script lang="ts">
	import { ButtonV2 } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import HomesOnboardingWizard from './HomesOnboardingWizard.svelte';

	let showHomesOnboarding = false;
</script>

<ButtonV2
	variant="secondary"
	size="m"
	on:click={() => (showHomesOnboarding = true)}
	aria-label={$format('link_learn_more', { default: 'Learn more' })}
>
	{$format('link_learn_more', { default: 'Learn more' })}
</ButtonV2>

<HomesOnboardingWizard bind:showModal={showHomesOnboarding} />

